export const isFullStatic = false
export const staticPath = "/home/runner/work/doctors_station_nuxt/doctors_station_nuxt/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"